import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PackageFormBody } from '../models/package';
import { PromiseResult } from '../models/PromiseResult';
import { RestApi } from '../shared/apiUrls';

@Injectable({
    providedIn: 'root'
})
export class PackagesService {
    constructor(private readonly http: HttpClient) { }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    list(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.PackageAPI + 'list')
            .pipe(catchError(this.handleError));
    }

    status(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.PackageAPI + 'status')
            .pipe(catchError(this.handleError));
    }

    purchase(body: PackageFormBody): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.PackageAPI + 'purchase', body)
            .pipe(catchError(this.handleError));
    }

    extend(user_package_id: string): Observable<PromiseResult> {
        return this.http
            .patch<PromiseResult>(RestApi.Urls.PackageAPI + 'extend/' + user_package_id, {})
            .pipe(catchError(this.handleError));
    }
}
